import configHelper from 'helper/Config/configHelper';
import { isEmpty } from 'lodash';
import Constants from 'constants';
import config from 'config';
import APP from 'app';
import nodeConfig from 'configs/nodeConfig';

const { clientName = 'technnogram' } = config;
const { env = 'development' } = nodeConfig;

const clientConfigDekorator = response => {
    const { status = {}, documents = [] } = response,
        [document = {}] = documents;
    let { data = '', key = '' } = document;
    const { success = false } = status;
    const _configCache = configHelper.decryptAndGet(Constants.module.CLIENT_CONFIGURATION_CACHE) || {},
        { timeLabel = '', content = {} } = _configCache,
        { hotel = '' } = configHelper.decryptAndGet(Constants.module.CONFIG_TOKENS);
    /**
     * put || clientName development to check local config 
     * isEmpty(data) || clientName == 'development'
     */
    if (isEmpty(data)) {
        let _jsEnv = env == 'development' ? 'development' : clientName;
        data = require(`../../../config/${_jsEnv}.js`);
    }
    configHelper.encryptJSONAndSave(
        Constants.module.CLIENT_CONFIGURATION_CACHE, {
            timeLabel: isEmpty(hotel) ? APP.Utils.currTimeSec() : hotel,
            content: data
        });
}

export default clientConfigDekorator;
